<template>
	<span :class="classes" v-if="isCircleShape">
		<FontAwesomeIcon
			class="teaming-checkbox__checked"
			:icon="['fas', 'circle-check']"
			v-if="isChecked"
			@click="onCheckboxClick"
		/>
		<FontAwesomeIcon
			class="teaming-checkbox__unchecked"
			:icon="['far', 'circle']"
			v-else
			@click="onCheckboxClick"
		/>
	</span>
	<!-- square is the default -->
	<span :class="classes" v-else>
		<FontAwesomeIcon
			class="teaming-checkbox__checked"
			:icon="['fas', 'check-square']"
			v-if="isChecked"
			@click="onCheckboxClick"
		/>
		<FontAwesomeIcon
			class="teaming-checkbox__unchecked"
			:icon="['far', 'square']"
			v-else
			@click="onCheckboxClick"
		/>
	</span>
</template>

<script>
export const THEME_PRIMARY = "primary";
export const THEME_SECONDARY = "secondary";
export const THEME_DEFAULT = THEME_PRIMARY;

export default {
	name: "TeamingCheckbox",
	emits: [
		"change",
		"input",
	],
	props: {
		className: {
			type: String,
			default: "",
		},
		name: {
			type: String,
			required: true,
		},
		isChecked: {
			type: Boolean,
			required: true,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
		value: {
			type: String,
			default: "1",
		},
		theme: {
			type: String,
			default: THEME_DEFAULT,
			validator: prop => [
				THEME_PRIMARY,
				THEME_SECONDARY,
			].includes( prop ),
		},
	},
	computed: {
		classes() {
			return {
				"teaming-checkbox": true,
				"theme--primary": this.isSquareShape,
				"theme--secondary": this.isCircleShape,
				"teaming-checkbox--square": this.isSquareShape,
				"teaming-checkbox--circle": this.isCircleShape,
				"teaming-checkbox--disabled": this.isDisabled,
				[ this.className ]: !!this.className,
			};
		},
		isSquareShape() {
			return this.theme === THEME_PRIMARY;
		},
		isCircleShape() {
			return this.theme === THEME_SECONDARY;
		},
	},
	methods: {
		onCheckboxClick( e ) {
			if ( this.isDisabled ) {
				return;
			}
			const { name, isChecked, value, } = this;
			const payload = {
				isChecked: !isChecked,
				name,
				value,
				// TODO: we should not be obscuring the DOM event like this, update at some point
				event: e,
			};
			this.$emit( "change", payload );
			this.$emit( "input", payload );
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-checkbox {
	cursor: pointer;
}

.teaming-checkbox--disabled {
	cursor: not-allowed;

	.teaming-checkbox__checked {
		color: $teaming-checkbox-checked-color--disabled;
		border: .09375rem solid $teaming-checkbox-checked-border-color--disabled;
	}
}

.teaming-checkbox.theme--primary .teaming-checkbox__checked {
	color: $teaming-checkbox-primary-checked-color;

	&:hover {
		color: $teaming-checkbox-primary-checked-color--hover;
	}

	&:focus {
		color: $teaming-checkbox-primary-checked-color--focus;
		border: .09375rem solid $teaming-checkbox-primary-checked-border-color--focus;
		box-shadow: 0 0 0 .1875rem $teaming-checkbox-primary-checked-shadow-color--focus, 0 .1875rem .4375rem rgba(42, 47, 69, 0.1), 0 .3125rem .5rem -.0625rem rgba(42, 47, 69, 0.05);
	}
}

.teaming-checkbox.theme--primary .teaming-checkbox__unchecked {
	color: $teaming-checkbox-primary-unchecked-color;

	&:hover {
		color: $teaming-checkbox-primary-unchecked-color--hover;
	}

	&:focus {
		color: $teaming-checkbox-primary-unchecked-color--focus;
		box-shadow: 0 0 0 .1875rem $teaming-checkbox-primary-unchecked-shadow-color--focus, 0 .1875rem .4375rem rgba(42, 47, 69, 0.1), 0 .3125rem .5rem -.0625rem rgba(42, 47, 69, 0.05);
	}
}

.teaming-checkbox.theme--secondary .teaming-checkbox__checked {
	color: $teaming-checkbox-secondary-checked-color;

	&:hover {
		color: $teaming-checkbox-secondary-checked-color--hover;
	}

	&:focus {
		color: $teaming-checkbox-secondary-checked-color--focus;
		border: .09375rem solid $teaming-checkbox-secondary-checked-border-color--focus;
		box-shadow: 0 0 0 .1875rem $teaming-checkbox-secondary-checked-shadow-color--focus, 0 .1875rem .4375rem rgba(42, 47, 69, 0.1), 0 .3125rem .5rem -.0625rem rgba(42, 47, 69, 0.05);
	}
}

.teaming-checkbox.theme--secondary .teaming-checkbox__unchecked {
	color: $teaming-checkbox-secondary-unchecked-color;

	&:hover {
		color: $teaming-checkbox-secondary-unchecked-color--hover;
	}

	&:focus {
		color: $teaming-checkbox-secondary-unchecked-color--focus;
		box-shadow: 0 0 0 .1875rem $teaming-checkbox-secondary-unchecked-shadow-color--focus, 0 .1875rem .4375rem rgba(42, 47, 69, 0.1), 0 .3125rem .5rem -.0625rem rgba(42, 47, 69, 0.05);
	}
}
</style>
